export default __webpack_public_path__ + "static/media/arrow-down-dark.cb72b63f.svg";